/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_SecurityInputs */

const en_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const zh_hans1_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全`)
};

const pt_br2_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurança`)
};

const es_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguridad`)
};

const fr_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité`)
};

const de_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit`)
};

const ru_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасность`)
};

const it_footer_security = /** @type {(inputs: Footer_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicurezza`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {Footer_SecurityInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_security = /** @type {((inputs?: Footer_SecurityInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_SecurityInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_security(inputs)
	if (locale === "pt-BR") return pt_br2_footer_security(inputs)
	if (locale === "es") return es_footer_security(inputs)
	if (locale === "fr") return fr_footer_security(inputs)
	if (locale === "de") return de_footer_security(inputs)
	if (locale === "ru") return ru_footer_security(inputs)
	if (locale === "it") return it_footer_security(inputs)
	return en_footer_security(inputs)
});